import { useState } from "react";
import { FeedTag } from "@routes/Keyword/utils/types";
import axios, { HttpStatusCode } from "axios";

/**
 * This is the hook for the search keywords for the MyBTOnboardPage.
 * It fetches the search results from the API and stores them in the state.
 */
export const useMyBTSearchKeywords = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchResults, setSearchResults] = useState<FeedTag[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async (query: string) => {
    setIsLoading(true);
    await fetchMyBtSearchKeywords(query)
      .then((keywords) => {
        setSearchResults(keywords);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setSearchResults([]);
    setIsLoading(false);
  };

  const handleSetSearchQuery = (results: string) => {
    setSearchQuery(results);
  };

  return {
    searchQuery,
    searchResults,
    handleSearch,
    handleSetSearchQuery,
    handleClearSearch,
    isLoading,
  };
};

const fetchMyBtSearchKeywords = async (
  search: string
): Promise<FeedTag[] | []> => {
  const response = await axios.post<FeedTag[] | []>(
    "/_plat/api/v1/mybt/search",
    { tagName: search }
  );

  if (response.status !== HttpStatusCode.Ok) return [];

  return response.data;
};
